var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle',_vm._g(_vm._b({staticClass:"hlt-toggle",style:(_vm.styles),attrs:{"on-label":_vm.labels.checked,"off-label":_vm.labels.unchecked,"value":_vm.value}},'toggle',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }